// Culture Antique signature antique-gold product photographs.
const panels = [
  { src: "/assets/collection/panel-001.jpg" },
  { src: "/assets/collection/panel-002.jpg" },
  { src: "/assets/collection/panel-003.jpg" },
  { src: "/assets/collection/panel-004.jpg" },
  { src: "/assets/collection/panel-005.jpg" },
  { src: "/assets/collection/panel-006.jpg" },
  { src: "/assets/collection/panel-007.jpg" },
  { src: "/assets/collection/panel-008.jpg" },
  { src: "/assets/collection/panel-009.jpg" },
  { src: "/assets/collection/panel-010.jpg" },
  { src: "/assets/collection/panel-011.jpg" },
];

export default panels;
